import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a0f9c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  id: "new-stickers-row"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "circle gradient-primary" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " When you beat a lesson and earn a sticker, this is where they will show up! ", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_indicator = _resolveComponent("loading-indicator")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.stickers)
      ? (_openBlock(), _createBlock(_component_loading_indicator, {
          key: 0,
          class: "col"
        }))
      : (_ctx.stickers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stickers, (sticker) => {
              return (_openBlock(), _createElementBlock("img", {
                key: sticker.lessonId,
                src: sticker?.imageUrl ?? '',
                class: "img-fluid sticker-sizing",
                alt: `${sticker.lessonName} Sticker`
              }, null, 8, _hoisted_2))
            }), 128)),
            (_ctx.numberOfStickers > 4)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.routePaths.collection,
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createTextVNode(" +" + _toDisplayString(_ctx.numberOfStickers - 3) + " More ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        class: "ms-2",
                        size: "sm",
                        icon: "arrow-right"
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
  ]))
}